<template>
  <bh-modal-overlay :showModal="showModal" @modal-close="closeModal">
    <div class="confirmation-card bg-white display-flex flex-column justify-around minw40 minh15 ph2">
      <div class="display-flex flex-column text-left">
        <h2>{{ title }}</h2>
        <div v-if="subTitle" class="text-grey mt1 f1-3"> {{ subTitle }}</div>
      </div>
      <div class="buttons-container display-flex justify-end f1-4">
        <span @click="emitValue(false)" class="mr2 pointer"> {{ cancelButtonLabel }} </span>
        <span @click="emitValue(true)" class="color-blue pointer"> {{ confirmButtonLabel }} </span>
      </div>
    </div>
  </bh-modal-overlay>
</template>

<script>
export default {
  name: 'bh-confirmation-modal',
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'Do you really want to do this?'
    },
    subTitle: {
      type: String,
      default: ''
    },
    confirmButtonLabel: {
      type: String,
      default: 'Yes'
    },
    cancelButtonLabel: {
      type: String,
      default: 'Cancel'
    }
  },
  methods: {
    emitValue(isConfirmed) {
      this.closeModal()
      this.$emit('output', isConfirmed)
    },
    closeModal() {
      this.$emit('update:showModal', false)
    }
  }
}
</script>

<style scoped>
  .buttons-container span:hover {
    color: #5764b3;
  }
</style>
